import { match } from 'ts-pattern'
import { AutomationExecution } from '../types'
import {
  IconCheckCircle,
  IconCircleX,
  GreenGreen70,
  RedRed70
} from '@sequencehq/core-components'

export const getAutomationStatusIcon = (
  status: AutomationExecution['status']
) => {
  return match(status)
    .with('RUNNING', () => null)
    .with('COMPLETED', () => <IconCheckCircle color={GreenGreen70} />)
    .with('TERMINATED', 'FAILED', () => <IconCircleX color={RedRed70} />)
    .exhaustive()
}
